import {cn} from "@/lib/utils";

import {ShiftType} from "../types";

/** Coverage list only includes normal and patrol active shifts. */
export const COVERAGE_SHIFT_TYPES = [ShiftType.NORMAL, ShiftType.PATROL] as const;

const LEGEND_SWATCH: Partial<Record<ShiftType, string>> = {
  [ShiftType.NORMAL]: "bg-sky-200/70 dark:bg-sky-900/50",
  [ShiftType.PATROL]: "bg-amber-200/70 dark:bg-amber-900/50",
};

const CARD_SURFACE: Partial<Record<ShiftType, {default: string; selected: string}>> = {
  [ShiftType.NORMAL]: {
    default: "border-sky-100/90 bg-sky-50/50 dark:border-sky-900/40 dark:bg-sky-950/25",
    selected: "border-sky-200/90 bg-sky-50/90 shadow-sm dark:border-sky-800/60 dark:bg-sky-950/40",
  },
  [ShiftType.PATROL]: {
    default: "border-amber-100/90 bg-amber-50/50 dark:border-amber-900/40 dark:bg-amber-950/25",
    selected:
      "border-amber-200/90 bg-amber-50/90 shadow-sm dark:border-amber-800/60 dark:bg-amber-950/40",
  },
};

const SELECTED_ACCENT: Partial<Record<ShiftType, string>> = {
  [ShiftType.NORMAL]: "before:bg-sky-500 dark:before:bg-sky-400",
  [ShiftType.PATROL]: "before:bg-amber-500 dark:before:bg-amber-400",
};

const DEFAULT_CARD_SURFACE = CARD_SURFACE[ShiftType.NORMAL]!;
const DEFAULT_SELECTED_ACCENT = SELECTED_ACCENT[ShiftType.NORMAL]!;

export function getCoverageShiftTypeSwatchClass(shiftType: ShiftType) {
  return LEGEND_SWATCH[shiftType] ?? LEGEND_SWATCH[ShiftType.NORMAL]!;
}

export function getCoverageShiftTypeCardClass(
  shiftType: ShiftType,
  isSelected: boolean,
  options?: {accent?: boolean},
) {
  const surface = CARD_SURFACE[shiftType] ?? DEFAULT_CARD_SURFACE;
  const showAccent = options?.accent !== false;

  return cn(
    "relative",
    surface[isSelected ? "selected" : "default"],
    "transition-[box-shadow,background-color]",
    !isSelected && "hover:brightness-[0.98] dark:hover:brightness-110",
    isSelected &&
      showAccent && [
        "pl-3.5",
        "before:absolute before:top-2 before:bottom-2 before:left-0 before:w-1 before:rounded-r-sm before:content-['']",
        SELECTED_ACCENT[shiftType] ?? DEFAULT_SELECTED_ACCENT,
      ],
  );
}
